export default __webpack_public_path__ + "static/nuvo-thumbnail-4fb4f86481e8d7ea9fc7440f10bb5082.webp";